import { render, staticRenderFns } from "./QuestionListWidget.vue?vue&type=template&id=42297c07"
import script from "./QuestionListWidget.vue?vue&type=script&lang=js"
export * from "./QuestionListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports